// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.norm-modal-overlay {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.45);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1100;
	overflow-y: auto;
	overflow-x: hidden;
	padding: 24px 16px;
}

.norm-modal {
	background: #ffffff;
	border-radius: 10px;
	width: 560px;
	max-width: 94vw;
	max-height: 88vh;
	display: flex;
	flex-direction: column;
	box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
	overflow: hidden;
}

/* ?? Header ?? */
.norm-modal-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px 20px;
	border-bottom: 1px solid #e9ecef;
	background: #f5f7fb;
}

.norm-modal-header h3 {
	margin: 0;
	font-size: 17px;
	color: #1c2b61;
}

.norm-modal-close {
	background: none;
	border: none;
	font-size: 22px;
	cursor: pointer;
	color: #666;
	line-height: 1;
	padding: 0 4px;
}

.norm-modal-close:hover {
	color: #333;
}

/* ?? Scrollable body ?? */
.norm-modal-body {
	padding: 16px 20px;
	overflow-y: auto;
	overflow-x: hidden;
	flex: 1 1;
	display: flex;
	flex-direction: column;
	gap: 14px;
	position: relative;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
}

.norm-modal-body::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}

/* ?? Pipeline step card ?? */
.norm-pipeline-step {
	border: 1px solid #d7e2ff;
	border-radius: 8px;
	background: #f9faff;
	overflow: visible;
	transition: opacity 0.2s;
}

.norm-pipeline-step.is-disabled {
	opacity: 0.55;
	background: #f5f5f5;
	border-color: #e0e0e0;
}

.norm-step-header {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 10px 14px;
	background: #eef3fd;
	border-bottom: 1px solid #d7e2ff;
	position: relative;
	z-index: 1;
}

.norm-pipeline-step.is-disabled .norm-step-header {
	background: #ececec;
	border-bottom-color: #e0e0e0;
}

.norm-checkbox-label {
	display: flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
	flex: 1 1;
	margin: 0;
}

.norm-checkbox-label input[type="checkbox"] {
	width: 16px;
	height: 16px;
	accent-color: #2f4fb5;
	cursor: pointer;
}

.norm-step-title {
	font-weight: 600;
	font-size: 14px;
	color: #1c2b61;
}

.norm-pipeline-options {
	display: flex;
	gap: 12px;
	flex-wrap: wrap;
}

.norm-pipeline-option {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 8px 12px;
	border: 1px solid #d7e2ff;
	border-radius: 8px;
	background: #ffffff;
	cursor: pointer;
	font-size: 13px;
	color: #334;
}

.norm-pipeline-option input[type="radio"] {
	accent-color: #2f4fb5;
}

/* ?? Params area ?? */
.norm-step-params {
	padding: 12px 14px;
	display: flex;
	flex-direction: column;
	gap: 10px;
	position: relative;
}

.norm-param-row {
	display: flex;
	align-items: center;
	gap: 10px;
}

.norm-param-row-control {
	flex: 1 1;
	min-width: 0;
	display: flex;
	align-items: center;
	min-height: 36px;
}

.norm-param-row-control--checkbox {
	justify-content: flex-start;
}

.norm-param-row-control--checkbox input[type="checkbox"] {
	width: 16px;
	height: 16px;
	accent-color: #2f4fb5;
	cursor: pointer;
}

.norm-param-row > label {
	width: 185px;
	flex: 0 0 185px;
	font-size: 13px;
	font-weight: 600;
	color: #495057;
	display: flex;
	align-items: center;
	gap: 6px;
	overflow: visible;
}

.norm-param-row input[type="number"],
.norm-param-row input[type="text"] {
	flex: 1 1;
	padding: 7px 10px;
	border: 1px solid #ccc;
	border-radius: 5px;
	font-size: 14px;
	transition: border-color 0.2s;
}

.norm-covariate-panel {
	flex: 1 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.norm-covariate-actions {
	display: flex;
	gap: 8px;
}

.norm-covariate-actions button {
	padding: 4px 10px;
	border: 1px solid #cfd6ea;
	border-radius: 14px;
	background: #f5f7ff;
	color: #2f4fb5;
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
}

.norm-covariate-actions button:hover {
	background: #e9eeff;
}

.norm-covariate-list {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 6px 10px;
	max-height: 140px;
	overflow-y: auto;
	padding: 8px;
	border: 1px solid #dfe5f5;
	border-radius: 6px;
	background: #fff;
}

.norm-covariate-item {
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 13px;
	color: #334;
	cursor: pointer;
	min-width: 0;
}

.norm-covariate-item input[type="checkbox"] {
	accent-color: #2f4fb5;
	width: 14px;
	height: 14px;
	flex-shrink: 0;
}

.norm-covariate-item span {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.norm-covariate-empty {
	font-size: 12px;
	color: #6c757d;
	padding: 6px 2px;
}

.norm-param-row input:focus {
	border-color: #2f4fb5;
	outline: none;
	box-shadow: 0 0 0 2px rgba(47, 79, 181, 0.12);
}

.norm-param-row select {
	flex: 1 1;
	padding: 7px 10px;
	border: 1px solid #ccc;
	border-radius: 5px;
	font-size: 14px;
	background: #fff;
	transition: border-color 0.2s;
}

.norm-param-row select:focus {
	border-color: #2f4fb5;
	outline: none;
}

.norm-select-placeholder {
	color: #999;
}

.norm-required {
	color: #e74c3c;
	font-weight: 700;
}

.norm-validation-hint {
	font-size: 12px;
	color: #e74c3c;
	white-space: nowrap;
}

/* Range inputs (Min-Max) */
.norm-param-row--inline {
	flex-wrap: wrap;
}

.norm-range-inputs {
	display: flex;
	align-items: center;
	gap: 8px;
	flex: 1 1;
}

.norm-range-inputs span {
	font-size: 13px;
	color: #666;
}

.norm-range-inputs input[type="number"] {
	width: 70px;
	flex: unset;
}

/* ?? Footer ?? */
.norm-modal-footer {
	padding: 14px 20px;
	border-top: 1px solid #e9ecef;
	display: flex;
	flex-direction: column;
	gap: 8px;
	align-items: flex-end;
}

.norm-footer-hint {
	font-size: 12px;
	color: #e74c3c;
	text-align: right;
	width: 100%;
}

.norm-footer-buttons {
	display: flex;
	gap: 10px;
}

.norm-btn-cancel {
	padding: 8px 18px;
	border: 1px solid #ccc;
	border-radius: 6px;
	background: #fff;
	color: #555;
	font-weight: 600;
	cursor: pointer;
	font-size: 14px;
	transition: background 0.2s;
}

.norm-btn-cancel:hover {
	background: #f5f5f5;
}

.norm-btn-normalize {
	padding: 8px 22px;
	border: none;
	border-radius: 6px;
	background: #2f4fb5;
	color: #fff;
	font-weight: 600;
	cursor: pointer;
	font-size: 14px;
	transition: background 0.2s, transform 0.2s;
}

.norm-btn-normalize:hover {
	background: #1f3a8c;
	transform: translateY(-1px);
}

.norm-btn-normalize:disabled {
	background: #aab6ff;
	cursor: not-allowed;
	transform: none;
	opacity: 0.7;
}

/* Tooltip layering inside modal */
.norm-modal .help-tooltip-content {
	z-index: 2000 !important;
}

body.norm-modal-open {
	overflow: hidden;
}

/* ?? Responsive ?? */
@media (max-width: 600px) {
	.norm-modal {
		width: 98vw;
		max-height: 94vh;
	}

	.norm-param-row {
		flex-direction: column;
		align-items: flex-start;
		gap: 4px;
	}

	.norm-param-row > label {
		width: unset;
		flex: none;
	}

	.norm-param-row input,
	.norm-param-row select {
		width: 100%;
	}

	.norm-covariate-list {
		grid-template-columns: 1fr;
	}
}
`, "",{"version":3,"sources":["webpack://./src/css/NormalizationConfigModal.css"],"names":[],"mappings":";AACA;CACC,eAAe;CACf,QAAQ;CACR,+BAA+B;CAC/B,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,aAAa;CACb,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,sBAAsB;CACtB,2CAA2C;CAC3C,gBAAgB;AACjB;;AAEA,iBAAiB;AACjB;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,kBAAkB;CAClB,gCAAgC;CAChC,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,eAAe;CACf,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,eAAe;CACf,eAAe;CACf,WAAW;CACX,cAAc;CACd,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA,0BAA0B;AAC1B;CACC,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,SAAO;CACP,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,kBAAkB;EACjB,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,GAAG,0BAA0B;AACvD;;AAEA;EACE,aAAa,EAAE,sBAAsB;AACvC;;AAEA,6BAA6B;AAC7B;CACC,yBAAyB;CACzB,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;CACjB,wBAAwB;AACzB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,kBAAkB;CAClB,mBAAmB;CACnB,gCAAgC;CAChC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,mBAAmB;CACnB,4BAA4B;AAC7B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,SAAO;CACP,SAAS;AACV;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,aAAa;CACb,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,iBAAiB;CACjB,yBAAyB;CACzB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sBAAsB;AACtB;CACC,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,SAAO;CACP,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,iBAAiB;AAClB;;AAEA;;CAEC,SAAO;CACP,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;CACf,6BAA6B;AAC9B;;AAEA;CACC,SAAO;CACP,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,QAAQ;AACT;;AAEA;CACC,iBAAiB;CACjB,yBAAyB;CACzB,mBAAmB;CACnB,mBAAmB;CACnB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,gDAAgD;CAChD,aAAa;CACb,iBAAiB;CACjB,gBAAgB;CAChB,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,WAAW;CACX,eAAe;CACf,YAAY;AACb;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,aAAa;CACb,6CAA6C;AAC9C;;AAEA;CACC,SAAO;CACP,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,6BAA6B;AAC9B;;AAEA;CACC,qBAAqB;CACrB,aAAa;AACd;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;AACpB;;AAEA,2BAA2B;AAC3B;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,SAAO;AACR;;AAEA;CACC,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,WAAW;AACZ;;AAEA,iBAAiB;AACjB;CACC,kBAAkB;CAClB,6BAA6B;CAC7B,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,SAAS;AACV;;AAEA;CACC,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;CAChB,eAAe;CACf,eAAe;CACf,2BAA2B;AAC5B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,WAAW;CACX,gBAAgB;CAChB,eAAe;CACf,eAAe;CACf,2CAA2C;AAC5C;;AAEA;CACC,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,eAAe;CACf,YAAY;AACb;;AAEA,kCAAkC;AAClC;CACC,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,qBAAqB;AACrB;CACC;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;CACT;;CAEA;EACC,YAAY;EACZ,UAAU;CACX;;CAEA;;EAEC,WAAW;CACZ;;CAEA;EACC,0BAA0B;CAC3B;AACD","sourcesContent":["\n.norm-modal-overlay {\n\tposition: fixed;\n\tinset: 0;\n\tbackground: rgba(0, 0, 0, 0.45);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tz-index: 1100;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tpadding: 24px 16px;\n}\n\n.norm-modal {\n\tbackground: #ffffff;\n\tborder-radius: 10px;\n\twidth: 560px;\n\tmax-width: 94vw;\n\tmax-height: 88vh;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbox-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);\n\toverflow: hidden;\n}\n\n/* ?? Header ?? */\n.norm-modal-header {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 16px 20px;\n\tborder-bottom: 1px solid #e9ecef;\n\tbackground: #f5f7fb;\n}\n\n.norm-modal-header h3 {\n\tmargin: 0;\n\tfont-size: 17px;\n\tcolor: #1c2b61;\n}\n\n.norm-modal-close {\n\tbackground: none;\n\tborder: none;\n\tfont-size: 22px;\n\tcursor: pointer;\n\tcolor: #666;\n\tline-height: 1;\n\tpadding: 0 4px;\n}\n\n.norm-modal-close:hover {\n\tcolor: #333;\n}\n\n/* ?? Scrollable body ?? */\n.norm-modal-body {\n\tpadding: 16px 20px;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 14px;\n\tposition: relative;\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none;  /* Internet Explorer 10+ */\n}\n\n.norm-modal-body::-webkit-scrollbar {\n  display: none; /* Safari and Chrome */\n}\n\n/* ?? Pipeline step card ?? */\n.norm-pipeline-step {\n\tborder: 1px solid #d7e2ff;\n\tborder-radius: 8px;\n\tbackground: #f9faff;\n\toverflow: visible;\n\ttransition: opacity 0.2s;\n}\n\n.norm-pipeline-step.is-disabled {\n\topacity: 0.55;\n\tbackground: #f5f5f5;\n\tborder-color: #e0e0e0;\n}\n\n.norm-step-header {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tpadding: 10px 14px;\n\tbackground: #eef3fd;\n\tborder-bottom: 1px solid #d7e2ff;\n\tposition: relative;\n\tz-index: 1;\n}\n\n.norm-pipeline-step.is-disabled .norm-step-header {\n\tbackground: #ececec;\n\tborder-bottom-color: #e0e0e0;\n}\n\n.norm-checkbox-label {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tcursor: pointer;\n\tflex: 1;\n\tmargin: 0;\n}\n\n.norm-checkbox-label input[type=\"checkbox\"] {\n\twidth: 16px;\n\theight: 16px;\n\taccent-color: #2f4fb5;\n\tcursor: pointer;\n}\n\n.norm-step-title {\n\tfont-weight: 600;\n\tfont-size: 14px;\n\tcolor: #1c2b61;\n}\n\n.norm-pipeline-options {\n\tdisplay: flex;\n\tgap: 12px;\n\tflex-wrap: wrap;\n}\n\n.norm-pipeline-option {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 8px;\n\tpadding: 8px 12px;\n\tborder: 1px solid #d7e2ff;\n\tborder-radius: 8px;\n\tbackground: #ffffff;\n\tcursor: pointer;\n\tfont-size: 13px;\n\tcolor: #334;\n}\n\n.norm-pipeline-option input[type=\"radio\"] {\n\taccent-color: #2f4fb5;\n}\n\n/* ?? Params area ?? */\n.norm-step-params {\n\tpadding: 12px 14px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n\tposition: relative;\n}\n\n.norm-param-row {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n}\n\n.norm-param-row-control {\n\tflex: 1;\n\tmin-width: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tmin-height: 36px;\n}\n\n.norm-param-row-control--checkbox {\n\tjustify-content: flex-start;\n}\n\n.norm-param-row-control--checkbox input[type=\"checkbox\"] {\n\twidth: 16px;\n\theight: 16px;\n\taccent-color: #2f4fb5;\n\tcursor: pointer;\n}\n\n.norm-param-row > label {\n\twidth: 185px;\n\tflex: 0 0 185px;\n\tfont-size: 13px;\n\tfont-weight: 600;\n\tcolor: #495057;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 6px;\n\toverflow: visible;\n}\n\n.norm-param-row input[type=\"number\"],\n.norm-param-row input[type=\"text\"] {\n\tflex: 1;\n\tpadding: 7px 10px;\n\tborder: 1px solid #ccc;\n\tborder-radius: 5px;\n\tfont-size: 14px;\n\ttransition: border-color 0.2s;\n}\n\n.norm-covariate-panel {\n\tflex: 1;\n\tmin-width: 0;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n}\n\n.norm-covariate-actions {\n\tdisplay: flex;\n\tgap: 8px;\n}\n\n.norm-covariate-actions button {\n\tpadding: 4px 10px;\n\tborder: 1px solid #cfd6ea;\n\tborder-radius: 14px;\n\tbackground: #f5f7ff;\n\tcolor: #2f4fb5;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\tcursor: pointer;\n}\n\n.norm-covariate-actions button:hover {\n\tbackground: #e9eeff;\n}\n\n.norm-covariate-list {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, minmax(0, 1fr));\n\tgap: 6px 10px;\n\tmax-height: 140px;\n\toverflow-y: auto;\n\tpadding: 8px;\n\tborder: 1px solid #dfe5f5;\n\tborder-radius: 6px;\n\tbackground: #fff;\n}\n\n.norm-covariate-item {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 6px;\n\tfont-size: 13px;\n\tcolor: #334;\n\tcursor: pointer;\n\tmin-width: 0;\n}\n\n.norm-covariate-item input[type=\"checkbox\"] {\n\taccent-color: #2f4fb5;\n\twidth: 14px;\n\theight: 14px;\n\tflex-shrink: 0;\n}\n\n.norm-covariate-item span {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.norm-covariate-empty {\n\tfont-size: 12px;\n\tcolor: #6c757d;\n\tpadding: 6px 2px;\n}\n\n.norm-param-row input:focus {\n\tborder-color: #2f4fb5;\n\toutline: none;\n\tbox-shadow: 0 0 0 2px rgba(47, 79, 181, 0.12);\n}\n\n.norm-param-row select {\n\tflex: 1;\n\tpadding: 7px 10px;\n\tborder: 1px solid #ccc;\n\tborder-radius: 5px;\n\tfont-size: 14px;\n\tbackground: #fff;\n\ttransition: border-color 0.2s;\n}\n\n.norm-param-row select:focus {\n\tborder-color: #2f4fb5;\n\toutline: none;\n}\n\n.norm-select-placeholder {\n\tcolor: #999;\n}\n\n.norm-required {\n\tcolor: #e74c3c;\n\tfont-weight: 700;\n}\n\n.norm-validation-hint {\n\tfont-size: 12px;\n\tcolor: #e74c3c;\n\twhite-space: nowrap;\n}\n\n/* Range inputs (Min-Max) */\n.norm-param-row--inline {\n\tflex-wrap: wrap;\n}\n\n.norm-range-inputs {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tflex: 1;\n}\n\n.norm-range-inputs span {\n\tfont-size: 13px;\n\tcolor: #666;\n}\n\n.norm-range-inputs input[type=\"number\"] {\n\twidth: 70px;\n\tflex: unset;\n}\n\n/* ?? Footer ?? */\n.norm-modal-footer {\n\tpadding: 14px 20px;\n\tborder-top: 1px solid #e9ecef;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n\talign-items: flex-end;\n}\n\n.norm-footer-hint {\n\tfont-size: 12px;\n\tcolor: #e74c3c;\n\ttext-align: right;\n\twidth: 100%;\n}\n\n.norm-footer-buttons {\n\tdisplay: flex;\n\tgap: 10px;\n}\n\n.norm-btn-cancel {\n\tpadding: 8px 18px;\n\tborder: 1px solid #ccc;\n\tborder-radius: 6px;\n\tbackground: #fff;\n\tcolor: #555;\n\tfont-weight: 600;\n\tcursor: pointer;\n\tfont-size: 14px;\n\ttransition: background 0.2s;\n}\n\n.norm-btn-cancel:hover {\n\tbackground: #f5f5f5;\n}\n\n.norm-btn-normalize {\n\tpadding: 8px 22px;\n\tborder: none;\n\tborder-radius: 6px;\n\tbackground: #2f4fb5;\n\tcolor: #fff;\n\tfont-weight: 600;\n\tcursor: pointer;\n\tfont-size: 14px;\n\ttransition: background 0.2s, transform 0.2s;\n}\n\n.norm-btn-normalize:hover {\n\tbackground: #1f3a8c;\n\ttransform: translateY(-1px);\n}\n\n.norm-btn-normalize:disabled {\n\tbackground: #aab6ff;\n\tcursor: not-allowed;\n\ttransform: none;\n\topacity: 0.7;\n}\n\n/* Tooltip layering inside modal */\n.norm-modal .help-tooltip-content {\n\tz-index: 2000 !important;\n}\n\nbody.norm-modal-open {\n\toverflow: hidden;\n}\n\n/* ?? Responsive ?? */\n@media (max-width: 600px) {\n\t.norm-modal {\n\t\twidth: 98vw;\n\t\tmax-height: 94vh;\n\t}\n\n\t.norm-param-row {\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tgap: 4px;\n\t}\n\n\t.norm-param-row > label {\n\t\twidth: unset;\n\t\tflex: none;\n\t}\n\n\t.norm-param-row input,\n\t.norm-param-row select {\n\t\twidth: 100%;\n\t}\n\n\t.norm-covariate-list {\n\t\tgrid-template-columns: 1fr;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
